function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
import { themeDefault, getMediaConditions } from '@shopify/polaris-tokens';
import { isServer } from './target.js';
import { useIsomorphicLayoutEffect } from './use-isomorphic-layout-effect.js';
var Breakpoints = {
  // TODO: Update to smDown
  navigationBarCollapsed: '767.95px',
  // TODO: Update to lgDown
  stackedContent: '1039.95px'
};
var noWindowMatches = {
  media: '',
  addListener: noop,
  removeListener: noop,
  matches: false,
  onchange: noop,
  addEventListener: noop,
  removeEventListener: noop,
  dispatchEvent: function dispatchEvent(_) {
    return true;
  }
};
function noop() {}
function navigationBarCollapsed() {
  return typeof window === 'undefined' ? noWindowMatches : window.matchMedia("(max-width: ".concat(Breakpoints.navigationBarCollapsed, ")"));
}
function stackedContent() {
  return typeof window === 'undefined' ? noWindowMatches : window.matchMedia("(max-width: ".concat(Breakpoints.stackedContent, ")"));
}

/**
 * Directional alias for each Polaris `breakpoints` token.
 *
 * @example 'smUp' | 'smDown' | 'smOnly' | 'mdUp' | etc.
 */

/**
 * Match results for each directional Polaris `breakpoints` alias.
 */

var breakpointsQueryEntries = getBreakpointsQueryEntries(themeDefault.breakpoints);
function getMatches(defaults,
/**
 * Used to force defaults on initial client side render so they match SSR
 * values and hence avoid a Hydration error.
 */
forceDefaults) {
  if (!isServer && !forceDefaults) {
    return Object.fromEntries(breakpointsQueryEntries.map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        directionAlias = _ref2[0],
        query = _ref2[1];
      return [directionAlias, window.matchMedia(query).matches];
    }));
  }
  if (_typeof(defaults) === 'object' && defaults !== null) {
    return Object.fromEntries(breakpointsQueryEntries.map(function (_ref3) {
      var _defaults$directionAl;
      var _ref4 = _slicedToArray(_ref3, 1),
        directionAlias = _ref4[0];
      return [directionAlias, (_defaults$directionAl = defaults[directionAlias]) !== null && _defaults$directionAl !== void 0 ? _defaults$directionAl : false];
    }));
  }
  return Object.fromEntries(breakpointsQueryEntries.map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 1),
      directionAlias = _ref6[0];
    return [directionAlias, defaults !== null && defaults !== void 0 ? defaults : false];
  }));
}
/**
 * Retrieves media query matches for each directional Polaris `breakpoints` alias.
 *
 * @example
 * const {smUp} = useBreakpoints();
 * return smUp && 'Hello world';
 *
 * @example
 * const {mdUp} = useBreakpoints({defaults: {mdUp: true}});
 * mdUp //=> `true` during SSR
 *
 * @example
 * const breakpoints = useBreakpoints({defaults: true});
 * breakpoints //=> All values will be `true` during SSR
 */
function useBreakpoints(options) {
  // On SSR, and initial CSR, we force usage of the defaults to avoid a
  // hydration mismatch error.
  // Later, in the effect, we will call this again on the client side without
  // any defaults to trigger a more accurate client side evaluation.
  var _useState = useState(getMatches(options === null || options === void 0 ? void 0 : options.defaults, true)),
    _useState2 = _slicedToArray(_useState, 2),
    breakpoints = _useState2[0],
    setBreakpoints = _useState2[1];
  useIsomorphicLayoutEffect(function () {
    var mediaQueryLists = breakpointsQueryEntries.map(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
        _ = _ref8[0],
        query = _ref8[1];
      return window.matchMedia(query);
    });
    var handler = function handler() {
      return setBreakpoints(getMatches());
    };
    mediaQueryLists.forEach(function (mql) {
      if (mql.addListener) {
        mql.addListener(handler);
      } else {
        mql.addEventListener('change', handler);
      }
    });

    // Trigger the breakpoint recalculation at least once client-side to ensure
    // we don't have stale default values from SSR.
    handler();
    return function () {
      mediaQueryLists.forEach(function (mql) {
        if (mql.removeListener) {
          mql.removeListener(handler);
        } else {
          mql.removeEventListener('change', handler);
        }
      });
    };
  }, []);
  return breakpoints;
}

/**
 * Converts `breakpoints` tokens into directional media query entries.
 *
 * @example
 * const breakpointsQueryEntries = getBreakpointsQueryEntries(breakpoints);
 * breakpointsQueryEntries === [
 *   ['xsUp', '(min-width: ...)'],
 *   ['xsDown', '(max-width: ...)'],
 *   ['xsOnly', '(min-width: ...) and (max-width: ...)'],
 *   ['smUp', '(min-width: ...) and (max-width: ...)'],
 *   ['mdUp', '(min-width: ...) and (max-width: ...)'],
 *   // etc.
 * ]
 */
function getBreakpointsQueryEntries(breakpoints) {
  var mediaConditionEntries = Object.entries(getMediaConditions(breakpoints));
  return mediaConditionEntries.map(function (_ref9) {
    var _ref10 = _slicedToArray(_ref9, 2),
      breakpointsToken = _ref10[0],
      mediaConditions = _ref10[1];
    return Object.entries(mediaConditions).map(function (_ref11) {
      var _ref12 = _slicedToArray(_ref11, 2),
        direction = _ref12[0],
        mediaCondition = _ref12[1];
      var breakpointsAlias = breakpointsToken.split('-')[1];

      // e.g. smUp, smDown, smOnly, etc.
      var directionAlias = "".concat(breakpointsAlias).concat(capitalize(direction));
      return [directionAlias, mediaCondition];
    });
  }).flat();
}
function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
export { getBreakpointsQueryEntries, navigationBarCollapsed, stackedContent, useBreakpoints };